var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "location-timeline-container" }, [
    _c("div", { staticClass: "scroll-bar-wrap", style: _vm.containerStyle }, [
      _vm.orderData.length > 0
        ? _c(
            "div",
            {
              ref: "locationTimeline",
              staticClass: "location-timeline scroll-box",
              attrs: { id: "locationTimeline" },
            },
            [
              _c("div", { staticClass: "header", style: _vm.rowStyle }, [
                _c("div", { staticClass: "gps-status" }, [
                  _c(
                    "div",
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: "location-arrow" },
                      }),
                    ],
                    1
                  ),
                  _c("div", [_vm._v(_vm._s(_vm.$t("planning.columns.gps")))]),
                ]),
                _c("div", { staticClass: "container-num" }, [
                  _c("div", [
                    _vm._v(_vm._s(_vm.$t("planning.columns.containerNum"))),
                  ]),
                  _c("div", [
                    _vm._v(_vm._s(_vm.$t("planning.columns.sealNum"))),
                  ]),
                ]),
                _c("div", { staticClass: "container-status" }, [
                  _c(
                    "div",
                    [_c("font-awesome-icon", { attrs: { icon: "lightbulb" } })],
                    1
                  ),
                  _c("div", [
                    _vm._v(_vm._s(_vm.$t("planning.columns.status"))),
                  ]),
                ]),
                _c("div", { staticClass: "route-type" }),
                _c(
                  "div",
                  { staticClass: "location-list" },
                  _vm._l(_vm.locationList, function (loc, locIndex) {
                    return _c(
                      "div",
                      { key: locIndex, staticClass: "location" },
                      [
                        _c("div", { staticClass: "ellipsis" }, [
                          _vm._v(_vm._s(loc.address)),
                        ]),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("planning.waypointType." + loc.type))
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _vm._l(_vm.orderData, function (order, orderIndex) {
                return _c(
                  "div",
                  {
                    key: orderIndex,
                    staticClass: "container-row",
                    style: _vm.rowStyle,
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "gps-status" },
                      [
                        _c("div", { staticClass: "mb-40px height-24px" }),
                        _c("div", { staticClass: "mb-40px height-24px" }, [
                          _vm._v(_vm._s(order.gpsData.deviceId)),
                        ]),
                        _c(
                          "el-button",
                          {
                            staticClass: "mt-1 mb-1",
                            staticStyle: { "text-transform": "uppercase" },
                            attrs: { type: "success", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.openMap(order, order["routeData"])
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("planning.map")) + " ")]
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "container-num" }, [
                      _c("div", { staticClass: "mb-40px height-24px" }, [
                        _vm._v(_vm._s(order.additionalData.containerNumber)),
                      ]),
                      _c("div", { staticClass: "mb-40px height-24px" }, [
                        _vm._v(_vm._s(order.additionalData.sealNumber)),
                      ]),
                      _c("div", { staticStyle: { height: "24px" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.getOrderInfo(
                              order["orderId"][0],
                              "ContainerSize"
                            )
                          )
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "container-status" },
                      [
                        _vm.getLatestWp(order.routeData)
                          ? [
                              _c(
                                "div",
                                { staticStyle: { "margin-bottom": "40px" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.locationList[
                                        _vm.getLatestWpIndex(order.routeData)
                                      ].address || ""
                                    )
                                  ),
                                ]
                              ),
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatTime(
                                      _vm.getLatestWpInfo(
                                        order.routeData,
                                        "startTime"
                                      ),
                                      "YYYY/MM/DD"
                                    )
                                  )
                                ),
                              ]),
                              _c(
                                "div",
                                { staticStyle: { "margin-bottom": "18px" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formatTime(
                                          _vm.getLatestWpInfo(
                                            order.routeData,
                                            "startTime"
                                          ),
                                          "HH:mm"
                                        )
                                      ) +
                                      " - " +
                                      _vm._s(
                                        _vm.formatTime(
                                          _vm.getLatestWpInfo(
                                            order.routeData,
                                            "endTime"
                                          ),
                                          "HH:mm"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c("div", { staticStyle: { height: "26px" } }, [
                                _vm.getLatestWpInfo(
                                  order.routeData,
                                  "waypointType"
                                ) === "T" &&
                                _vm.getLatestWpInfo(order.routeData, "gpsData")
                                  ? _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getActualTimeRailway(
                                              _vm.getLatestWp(order.routeData)
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatTime(
                                            _vm.getLatestWpInfo(
                                              order.routeData,
                                              "actualData"
                                            ).endTime,
                                            "YY/MM/DD HH:mm"
                                          ) || "-"
                                        )
                                      ),
                                    ]),
                              ]),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c("div", { staticClass: "route-type" }, [
                      _c("div", { staticClass: "mb-40px" }, [
                        _vm._v(_vm._s(_vm.$t("planning.planned"))),
                      ]),
                      _c("div", { staticStyle: { "margin-bottom": "44px" } }, [
                        _vm._v(_vm._s(_vm.$t("planning.actual"))),
                      ]),
                      _c("div", [_vm._v("-/+")]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "location-list" },
                      _vm._l(order.routeData, function (wp, wpIndex) {
                        return _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  order &&
                                  order.routeData &&
                                  order.routeData.length > 0,
                                expression:
                                  "order && order.routeData && order.routeData.length > 0",
                              },
                            ],
                            key: wpIndex,
                            staticClass: "location",
                          },
                          [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatTime(wp.startTime, "YYYY/MM/DD")
                                )
                              ),
                            ]),
                            _c(
                              "div",
                              { staticStyle: { "margin-bottom": "18px" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatTime(wp.startTime, "HH:mm")
                                  ) +
                                    " - " +
                                    _vm._s(_vm.formatTime(wp.endTime, "HH:mm"))
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "mb-1" },
                              [
                                [
                                  _vm.isWaypointFilledCircle(wp)
                                    ? _c("font-awesome-icon", {
                                        staticClass: "circle",
                                        class: _vm.getWaypointClass(
                                          wpIndex,
                                          order.routeData
                                        ),
                                        attrs: { icon: "circle" },
                                      })
                                    : _c("font-awesome-icon", {
                                        attrs: { icon: ["far", "circle"] },
                                      }),
                                ],
                              ],
                              2
                            ),
                            _c("div", { staticStyle: { height: "26px" } }, [
                              wp.waypointType === "T" && wp.gpsData
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.getActualTimeRailway(wp))
                                    ),
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatTime(
                                          wp.actualData.endTime,
                                          "YY/MM/DD HH:mm"
                                        ) || "-"
                                      )
                                    ),
                                  ]),
                            ]),
                            _c("div", { staticClass: "forecast-row" }, [
                              _c("div", { staticStyle: { height: "14px" } }),
                              wp.waypointType === "T" ? _c("span") : _vm._e(),
                              _c("span", [
                                _vm._v(_vm._s(_vm.getForecastValue(wp))),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                )
              }),
            ],
            2
          )
        : _c("div", [
            _c("p", { staticClass: "no-orders" }, [
              _vm._v(_vm._s("No Containers")),
            ]),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }